module.exports = ".table_sec_form .batp_btn:hover {\n    background-color: #ffffff!important;\n    color: #326E5F!important;\n}\n"